import { render } from "./platformManage.vue?vue&type=template&id=7cbc2d49"
import script from "./platformManage.vue?vue&type=script&lang=js"
export * from "./platformManage.vue?vue&type=script&lang=js"

import "./platformManage.vue?vue&type=style&index=0&id=7cbc2d49&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Stage-integrated-sugang-admin-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__